import React, { useEffect, useState } from 'react'
import email from '../../../Assets/email.png'
import instagram from '../../../Assets/instagram.png'
import linkedin from '../../../Assets/linkedin.png'
import discord from '../../../Assets/discord-mark-black.png'
import axios from 'axios'
import Aos from 'aos'
import 'aos/dist/aos.css'
const Socials = () => {

    const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbza9_l3eedwQmA70JDyNlBvYoZnUEJe0ZO4YezX9dIUiZ74T74vIz5Eat9U9zLJTg/exec';
    const [discordLink, setDiscordLink] = useState("");
    useEffect(() => {
        fetchLink();
    }, []);

    const fetchLink = async () => {
        try {
            const response = await axios.get(SCRIPT_URL, {
                params: {
                    type: "discord"
                }
            });
            setDiscordLink(response.data);
        } catch (error) {
            console.error('Error fetching link:', error);
        }
    };

    useEffect(() => {
        Aos.init({
            duration: 900
        })
    }, []);
    if (window.innerWidth > 500) {
        return (
            <div className='icons' data-aos="zoom-in" data-aos-offset="-100">
                <a href='https://www.instagram.com/ekidea.in/' target='_blank' rel="noreferrer"><img src={instagram} alt='instagram' className='icon' /></a>
                <a href={discordLink} target='_blank' rel="noreferrer" ><img src={discord} alt='discord' className='icon' id='discord' /></a>
                <a href='https://www.linkedin.com/company/ekidea/' target='_blank' rel="noreferrer"><img src={linkedin} alt='linkedin' className='icon' /></a>
                <a href='mailto:connect@ekidea.in' ><img src={email} alt='email' className='icon' /> </a>
            </div>
        )
    }
    else {
        return (
            <div className='icons'>
                <a href='https://www.instagram.com/ekidea.in/' target='_blank' rel="noreferrer"><img src={instagram} alt='instagram' className='icon' /></a>
                <a href={discordLink} target='_blank' rel="noreferrer" ><img src={discord} alt='discord' className='icon' id='discord' /></a>
                <a href='https://www.linkedin.com/company/ekidea/' target='_blank' rel="noreferrer"><img src={linkedin} alt='linkedin' className='icon' /></a>
                <a href='mailto:connect@ekidea.in' ><img src={email} alt='email' className='icon' /> </a>
            </div>
        )
    }
}

export default Socials